import {FirebaseDB} from "../config/setup-firestore";

export function api_getCommunity(community_uid) {
    return FirebaseDB
        .collection('communities')
        .doc(community_uid)
        .get()
}
